<app-listado-listado-categorias
  [categorias]="categorias"
  tooltipCrear="Crear tipo de evento"
  tituloCrear="Tipo de Evento"
></app-listado-listado-categorias>
